// extracted by mini-css-extract-plugin
export var Content = "Support-module--Content--K0OMv";
export var CurvyLine = "Support-module--CurvyLine--CKN8k";
export var Heading = "Support-module--Heading--Mu5xg";
export var Quotes = "Support-module--Quotes--GvHJp";
export var Review = "Support-module--Review--aaG5Y";
export var Reviews = "Support-module--Reviews--f-JHu";
export var ScheduleCall = "Support-module--ScheduleCall--uqANx";
export var Support = "Support-module--Support--10HJh";
export var ThumbsUp = "Support-module--ThumbsUp--KiWMG";